module.exports = __webpack_public_path__ + "img/part4-uIcon15.34ea3904.png";